import React from 'react';
import PropTypes from "prop-types";

function LocationPin ({ selected, onClick }) {

    const SIZE_NORMAL = 47;
    const SIZE_SELECTED = 79;

    const COLOR_NORMAL = '#a49271';
    const COLOR_SELECTED = '#8e411d';

    const size = selected ? SIZE_SELECTED : SIZE_NORMAL;
    const color = selected ? COLOR_SELECTED : COLOR_NORMAL;

    const pinStyleDefault = {
        position: 'absolute',
        transform: 'translate(-50%, -100%)'
    };

    const pinStyleSelected = {
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
        zIndex: '100'
    };

    const pinStyling = selected ? pinStyleSelected : pinStyleDefault;

    return (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 47.009 65.244" style={pinStyling} onClick={onClick}>
                <g transform="translate(-460.991 -330.379)">
                    <circle cx="10" cy="10" r="10" fill="#fff" transform="translate(474.566 348)"/>
                    <g transform="translate(461.232 333.141)">
                        <path fill={color} transform="translate(3.953 9.452)" d="M32.273,6.658a11.409,11.409,0,0,0-4.262-4.234C16-4.373,3.77,4.131,3.77,15.492c0,3.173,2.582,8.583,2.592,8.573L19.09,46.3a.2.2,0,0,0,.344,0L32.163,24.065c3.094-4.645,3.76-11.048.111-17.408M20.727,22.741a7.506,7.506,0,1,1,5.9-5.9,7.513,7.513,0,0,1-5.9,5.9" />
                    </g>
                </g>
            </svg>
    );
}

LocationPin.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

export default LocationPin;




// WEBPACK FOOTER //
// ./src/components/Map/LocationPin.js